//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalMarketRentalUnitsProposedWidget = ({ count }: { count: number }) => {
  return (
    <StatCard
      title='Total Market Rental Units Proposed'
      stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />}
    />
  );
};

export default TotalMarketRentalUnitsProposedWidget;
